export const loadingType = {
  SERVICE_PROVIDER: 'service_provider',
  DATE_TIME: 'date_time',
}
